module.exports = __webpack_public_path__ + "img/banner5.909f5603.png";